var map = {
	"./bonk/post.html": 5178,
	"./bonk/preview.html": 9609,
	"./click/post.html": 4246,
	"./click/preview.html": 7960,
	"./fish-and-crips/post.html": 8034,
	"./fish-and-crips/preview.html": 5960,
	"./neom/post.html": 8056,
	"./neom/preview.html": 4376,
	"./no-beaches/post.html": 9896,
	"./no-beaches/preview.html": 3920,
	"./stupi-square-and-sussy-circle/post.html": 9770,
	"./stupi-square-and-sussy-circle/preview.html": 5811,
	"./the-boomer/post.html": 727,
	"./the-boomer/preview.html": 4169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;